import React, { PureComponent } from 'react';
import Box from '@rexlabs/box';
import { styled, StyleSheet } from '@rexlabs/styling';
import { Grid, Column } from '@rexlabs/grid';
import { Small } from '../text';
import { Check as Checkbox } from 'view/components/checkbox';
import { COLORS } from 'src/theme';

const defaultStyles = StyleSheet({
  text: {
    fontWeight: '500',
    color: COLORS.GREY.DARK
  },
  container: {
    borderBottom: `1px solid ${COLORS.GREY.LIGHT}`
  },
  grid: {
    '> *': {
      padding: '1rem 2rem'
    }
  }
});

@styled(defaultStyles)
class ProjectWorksheetListHeader extends PureComponent {
  state = {
    addWorksheetModal: false
  };

  render() {
    const { styles: s, onSelectAll, checked } = this.props;
    return (
      <Box {...s('container')}>
        <Grid
          gutter={0}
          columns={24}
          style={{ alignItems: 'center' }}
          {...s('grid')}
        >
          <Column width={1} onClick={onSelectAll}>
            <Checkbox controlled value={!!checked} />
          </Column>
          <Column width={1} />
          <Column width={5}>
            <Small {...s('text')}>Period</Small>
          </Column>
          <Column width={4}>
            <Small {...s('text')}>Worksheet Status</Small>
          </Column>
          <Column width={4}>
            <Small {...s('text')}>Flags</Small>
          </Column>
          <Column width={4}>
            <Small {...s('text')}>Date Created</Small>
          </Column>
          <Column width={4}>
            <Small {...s('text')}>Last Edited</Small>
          </Column>
          <Column width={1} />
        </Grid>
      </Box>
    );
  }
}

export default ProjectWorksheetListHeader;
